import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IDataCardFE } from '../../../../../models/data-card.model'
import { TypicalFuncLabelEnum } from '../../../../../enums/typical-func-label.enum'
import { TypicalEquipmentLabelEnum } from '../../../../../enums/typical-equipment-label.enum'
import { HelperService } from '../../../../../services/helper.service'
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component'
import { NzModalService } from 'ng-zorro-antd/modal'

@Component({
    selector: 'app-data-valve',
    templateUrl: './data-valve.component.html',
    standalone: false
})
export class DataValveComponent {
  @Input() data: IDataCardFE
  @Input() ttmURLParams: any
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  @Output() openSDLEvent: EventEmitter<string> = new EventEmitter()

  constructor(private nzModalService: NzModalService) {}

  public getFuncLabel(typical: string): string {
    if (typical in TypicalFuncLabelEnum) {
      return TypicalFuncLabelEnum[typical]
    }
    return TypicalFuncLabelEnum.VLV
  }

  public getEqLabel(typical: string): string {
    if (typical in TypicalEquipmentLabelEnum) {
      return TypicalEquipmentLabelEnum[typical]
    }
    return TypicalEquipmentLabelEnum.VLV
  }

  public parseValue(value: any): string {
    return HelperService.getColorBulletHTML(value, '')
  }

  public getSIFParams(mo: string, isFE: boolean = false): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          feElem: isFE ? mo : null,
          trigger: !isFE ? mo : null,
        }),
      ),
    }
  }

  public onOpenNotificationModal(tag: string, notifications?: number): void {
    if (!notifications) {
      return
    }
    // const modal: NzModalRef<NotificationsModalComponent> =
    this.nzModalService.create<NotificationsModalComponent, { mainObject: string }, any>({
      nzContent: NotificationsModalComponent,
      nzStyle: { top: '30px' },
      nzData: { mainObject: tag },
      nzNoAnimation: true,
    })
    // modal.afterClose.subscribe((data) => console.log('[afterClos] emitted!', data));
  }

  public hasUrlBadges(type: 'MO' | 'C1' | 'C2'): boolean {
    switch (type) {
      case 'C1':
        return !!(
          this.data &&
          (this.data.Component_Dev_Active_1 ||
            this.data.Component_Dev_InActive_Count_1 ||
            this.data.Component_Flt_Active_1 ||
            this.data.Component_Flt_InActive_Count_1 ||
            this.data.Component_Ovr_Active_1 ||
            this.data.Component_Ovr_InActive_Count_1 ||
            this.data.Component_Dmd_Active_1 ||
            this.data.Component_Dmd_InActive_Count_1)
        )
      case 'C2':
        return !!(
          this.data &&
          (this.data.Component_Dev_Active_2 ||
            this.data.Component_Dev_InActive_Count_2 ||
            this.data.Component_Flt_Active_2 ||
            this.data.Component_Flt_InActive_Count_2 ||
            this.data.Component_Ovr_Active_2 ||
            this.data.Component_Ovr_InActive_Count_2 ||
            this.data.Component_Dmd_Active_2 ||
            this.data.Component_Dmd_InActive_Count_2)
        )
      default:
        return !!(
          this.data &&
          (this.data.Object_Dev_Active ||
            this.data.Object_Dev_InActive_Count ||
            this.data.Object_Flt_Active ||
            this.data.Object_Flt_InActive_Count ||
            this.data.Object_Ovr_Active ||
            this.data.Object_Ovr_InActive_Count ||
            this.data.Object_Dmd_Active ||
            this.data.Object_Dmd_InActive_Count)
        )
    }
  }

  public hasCurrentRating(currentRating: any): boolean {
    return !HelperService.isNullOrUndefined(currentRating)
  }

  public getSDLs(sdl?: string): string[] {
    if (sdl) {
      return sdl.split(',').map((item: string) => item.trim())
    }
    return []
  }

  public onOpenSDL(sdl: string): void {
    this.openSDLEvent.next(sdl)
  }
}
